export default __webpack_public_path__ + "static/media/move-arte-6.c2537fc3.webp";